import * as React from "react";
import { NavLink, Redirect } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { Formik, FieldArray, isObject } from "formik";
import CoreComponent from "./CoreComponent";
import { arrayToFormData } from "../utils/functions";
import config from "../config";
import Axios, { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import * as Yup from 'yup';
import { connect } from "react-redux";
import { IObject } from "../interfaces";
import * as qs from 'query-string';
// @ts-ignore
import Select2 from '../components/Select2';

interface IState {
    authors: { user_id: number, full_name: string }[],
    isLoading: boolean,
    object: IObject,
    objectAuthors: any[],
    objectCoauthors: any[]
}

class SingleObject extends CoreComponent<any, IState>{
    state: IState = {
        authors: [],
        isLoading: false,
        object: null,
        objectAuthors: [],
        objectCoauthors: []
    };

    async componentWillMount() {
        let response: AxiosResponse = await Axios.get(`${config.api}/user/list`);

        if (!this.isUnmounted) {
            this.setState({
                authors: response.data
            }, () => {

            })
        }

        if (this.props.match.params.id) {
            this.setState({
                isLoading: true
            }, async () => {
                let response: AxiosResponse = await Axios.get(`${config.api}/composition/get?id=${this.props.match.params.id}`);

                if (!this.isUnmounted) {
                    this.setState({
                        object: response.data.model,
                        objectAuthors: response.data.authors,
                        objectCoauthors: response.data.coauthors,
                        isLoading: false
                    });
                }
            })

        }
    }

    async handleSubmit(data: any, setErrors: any) {
        let { t } = this.props;

        let formData = arrayToFormData(data);

        if (!this.isUnmounted) {
            this.setState({
                isLoading: true,
            }, async () => {
                let response: any;

                response = await Axios.post(`${config.api}/composition/create`, formData);

                if (response.data.status == "error") {
                    let errors: any = {};

                    for (let prop in response.data.errors) {
                        errors[prop] = response.data.errors[prop].join(", ");
                        toast(response.data.errors[prop].join(", "), { type: "error" });
                    }

                    if (!this.isUnmounted) {
                        this.setState({
                            isLoading: false
                        });
                    }

                    setErrors(
                        errors
                    );
                } else {
                    if (!this.isUnmounted) {
                        toast(t("Успешно сохранён."), { type: "success" });
                        this.setState({
                            isLoading: false
                        });

                        this.props.history.goBack();
                    }
                }
            });
        }
    }

    componentDidUpdate() {

    }

    render() {
        let qsObj = qs.parse(this.props.location.search);

        let id = qsObj.id;

        let initialValues: any = this.props.match.params.id && this.state.object ? {
            name: this.state.object.name,
            id: this.state.object.id,
            youtube_id: this.state.object.youtube_id,
            place: this.state.object.place,
            authors: this.state.objectAuthors.length > 0 ? [...this.state.objectAuthors] : [{ user_id: "", rate: "60", created_at: "2019-01-01" }],
            coauthors: this.state.objectCoauthors.length > 0 ? [...this.state.objectCoauthors] : [{ user_id: "", rate: "0", created_at: "2019-01-01" }],
        } : {
            name: "",
            youtube_id: "",
            place: "",
            authors: [{ user_id: id || "", rate: "60", created_at: "2019-01-01" }],
            coauthors: [{ user_id: "", rate: "0", created_at: "2019-01-01" }]
        }

        let { t, auth } = this.props;

        if (!auth.isAuthentificated) return <Redirect to="/login" />;

        return (
            <div className="crm-holders">
                <div className="wrapper">
                    <NavLink className="crm-holders__back" to="/admin">
                        Назад
                    </NavLink>
                    <span className="crm-holders__title">
                        {!this.props.match.params.id && "Добавление нового объекта"}
                        {this.props.match.params.id && this.state.object?.holder && <><NavLink style={{ color: '#8d8e96' }} to="/admin/holders">Партнеры</NavLink> <div className="block-line"></div> <NavLink style={{ color: '#8d8e96' }} to={"/admin/holder/" + this.state.object?.holder.id}>{this.state.object?.holder.full_name}</NavLink> <div className="block-line"></div> {this.state.object.name}</>}
                    </span>
                    <div className="single-holder">
                        <div className="single-holder__items">
                            <div className="single-holder__item">
                                <span className="single-holder__title">
                                    {this.props.match.params.id && this.state.object?.holder && <>{this.state.object?.holder.full_name} <div className="block-line"></div> {this.state.object.name}</>}
                                </span>
                                <div className="single-holder__block">
                                    {this.props.match.params.id && this.state.object && this.state.object.place == "YouTube" && <object width="100%" height="100%" data={`https://www.youtube.com/v/${this.state.object.youtube_id}`} type="application/x-shockwave-flash">
                                        <param name="src" value={`http://www.youtube.com/v/${this.state.object.youtube_id}`} />
                                    </object>}
                                </div>
                            </div>
                            <div className="single-holder">
                                <Formik
                                    enableReinitialize={true}

                                    initialValues={initialValues}
                                    onSubmit={async (values, { setErrors }) => {
                                        await this.handleSubmit(values, setErrors);
                                    }}

                                    validationSchema={Yup.object().shape({
                                        name: Yup.string().required(),
                                        youtube_id: Yup.string().required(),
                                        place: Yup.string().required(),
                                        authors: Yup.array().of(Yup.object().shape({
                                            user_id: Yup.number().required(),
                                            rate: Yup.number().required(),
                                            created_at: Yup.string().required()
                                        })),
                                        coauthors: Yup.array().of(Yup.object().shape({
                                            user_id: Yup.number(),
                                            rate: Yup.number(),
                                            created_at: Yup.string()
                                        })),
                                    })}
                                >
                                    {(props) => {
                                        const {
                                            values,
                                            errors,
                                            handleChange,
                                            handleBlur,
                                            handleSubmit,
                                            touched,
                                            setErrors
                                        }: any = props;

                                        console.log (values);

                                        return (
                                            <form id="official-signup" onSubmit={handleSubmit}>
                                                <div className="single-form__items">
                                                    <div className="single-form__item">
                                                        <main>
                                                            <span>Название:</span>
                                                            <input
                                                                type="text"
                                                                placeholder="Название"
                                                                autoComplete="off"
                                                                name="name" value={values.name} onChange={handleChange} onBlur={handleBlur} className={(touched.name && errors.name ? "required" : "")}
                                                            />
                                                            <span>Площадка:</span>
                                                            <input
                                                                type="text"
                                                                autoComplete="off"
                                                                list="sources"
                                                                placeholder="Выберите площадку"
                                                                name="place" value={values.place} onChange={handleChange} onBlur={handleBlur} className={(touched.place && errors.place ? "required" : "")}
                                                            />
                                                            <datalist id="sources">
                                                                <option>YouTube</option>
                                                                <option>YouTube Music</option>
                                                                <option>RizaNova Music</option>
                                                            </datalist>
                                                            <span>Source ID:</span>
                                                            <input
                                                                type="text"
                                                                autoComplete="off"
                                                                placeholder="Введите ID от площадки..."
                                                                name="youtube_id" value={values.youtube_id} onChange={handleChange} onBlur={handleBlur} className={(touched.youtube_id && errors.youtube_id ? "required" : "")}
                                                            />
                                                            <FieldArray name="authors" render={arrayHelpers => {
                                                                return values.authors.map((author: any, i: number) => {
                                                                    return (
                                                                        <aside key={i} className="my-select2-container">
                                                                            <span>Автор:</span>
                                                                            <Select2
                                                                                options={this.state.authors}
                                                                                name={"authors." + i + ".user_id"} value={author.user_id} onChange={handleChange} onBlur={handleBlur} className={(touched.authors && touched.authors[i]?.user_id && errors.authors && errors.authors[i]?.user_id ? "required my-select2 visibility-hidden" : "my-select2 visibility-hidden")}
                                                                            />
                                                                            {/* <select ref={ref => {
                                                                                console.log(ref);
                                                                            }} name={"authors." + i + ".user_id"} value={author.user_id} onChange={handleChange} onBlur={handleBlur} className={(touched.authors && touched.authors[i]?.user_id && errors.authors && errors.authors[i]?.user_id ? "required my-select2 " : "my-select2 ")} >
                                                                                <option value="">Выберите правообладеля...</option>

                                                                                {this.state.authors.map((author: { user_id: number, full_name: string }, i: number) => {
                                                                                    return <option value={author.user_id} key={i}>{author.full_name}</option>
                                                                                })}
                                                                            </select> */}
                                                                        </aside>
                                                                    );
                                                                })
                                                            }} />

                                                            <FieldArray name="coauthors" render={arrayHelpers => {
                                                                return values.coauthors.map((author: any, i: number) => {
                                                                    return (
                                                                        <aside key={i} className="my-select2-container">
                                                                            <span>Со-автор:</span>
                                                                            <Select2
                                                                                options={this.state.authors}
                                                                                name={"coauthors." + i + ".user_id"} value={author.user_id} onChange={handleChange} onBlur={handleBlur} className={(touched.coauthors && touched.coauthors[i]?.user_id && errors.coauthors && errors.coauthors[i]?.user_id ? "required my-select2 visibility-hidden" : "my-select2 visibility-hidden")}
                                                                            />
                                                                            {/* <select name={"coauthors." + i + ".user_id"} value={author.user_id} onChange={handleChange} onBlur={handleBlur} className={(touched.authors && touched.authors[i]?.user_id && errors.authors && errors.authors[i]?.user_id ? "required my-select2 visibility-hidden" : "my-select2 visibility-hidden")} >
                                                                                <option value="">Выберите правообладеля...</option>
                                                                                {this.state.authors.map((author: { user_id: number, full_name: string }, i: number) => {
                                                                                    return <option value={author.user_id} key={i}>{author.full_name}</option>
                                                                                })}
                                                                            </select> */}
                                                                        </aside>
                                                                    );
                                                                })
                                                            }} />
                                                        </main>
                                                    </div>
                                                    <div
                                                        className="single-form__item"
                                                        style={{ display: "flex", flexWrap: "wrap", width: "210px" }}
                                                    >
                                                        <datalist id="rates">
                                                            <option>70</option>
                                                            <option>60</option>
                                                            <option>50</option>
                                                            <option>40</option>
                                                            <option>30</option>
                                                            <option>20</option>
                                                            <option>10</option>
                                                        </datalist>
                                                        <FieldArray name="authors" render={arrayHelpers => {
                                                            return values.authors.map((author: any, i: number) => {
                                                                return (
                                                                    <main style={i != 0 ? { marginTop: 0 } : {}} key={i}>
                                                                        <span>Ставка:</span>
                                                                        <div style={{ display: "flex" }}>
                                                                            <input
                                                                                style={{ width: "55px" }}
                                                                                type="number"
                                                                                autoComplete="off"
                                                                                list="rates"
                                                                                name={"authors." + i + ".rate"} value={author.rate} onChange={handleChange} onBlur={handleBlur} className={(touched.authors && touched.authors[i]?.rate && errors.authors && errors.authors[i]?.rate ? "required" : "")}
                                                                            />

                                                                            <div className="input-group date">
                                                                                <input
                                                                                    type="date"
                                                                                    autoComplete="off"
                                                                                    style={{ border: "1px solid #707070", width: "105px" }}
                                                                                    name={"authors." + i + ".created_at"} value={author.created_at} onChange={handleChange} onBlur={handleBlur} className={(touched.authors && touched.authors[i]?.created_at && errors.authors && errors.authors[i]?.created_at ? "form-control required" : "form-control")}
                                                                                />
                                                                            </div>
                                                                            {i == 0 ? <>
                                                                                <a className="add-box" role="button" onClick={() => {
                                                                                    arrayHelpers.push({
                                                                                        user_id: "",
                                                                                        rate: "60",
                                                                                        created_at: "2019-01-01"
                                                                                    });
                                                                                }}>
                                                                                    <img src="img/Icon material-add-box.png" alt="" />
                                                                                </a>
                                                                            </> : <a className="add-box" role="button" onClick={() => {
                                                                                arrayHelpers.remove(i);
                                                                            }}>
                                                                                <img src="img/Icon ionic-md-add.png" alt="" />
                                                                            </a>}
                                                                        </div>
                                                                    </main>
                                                                );
                                                            })
                                                        }} />
                                                        <FieldArray name="coauthors" render={arrayHelpers => {
                                                            return values.coauthors.map((author: any, i: number) => {
                                                                return (
                                                                    <main style={{ marginTop: 0 }} key={i}>
                                                                        <span>Ставка:</span>
                                                                        <div style={{ display: "flex" }}>
                                                                            <input
                                                                                style={{ width: "55px" }}
                                                                                type="number"
                                                                                list="rates"
                                                                                autoComplete="off"
                                                                                name={"coauthors." + i + ".rate"} value={author.rate} onChange={handleChange} onBlur={handleBlur} className={(touched.coauthors && touched.coauthors[i]?.rate && errors.coauthors && errors.coauthors[i]?.rate ? "required" : "")}
                                                                            />

                                                                            <div className="input-group date">
                                                                                <input
                                                                                    type="date"
                                                                                    autoComplete="off"
                                                                                    style={{ border: "1px solid #707070", width: "105px" }}
                                                                                    name={"coauthors." + i + ".created_at"} value={author.created_at} onChange={handleChange} onBlur={handleBlur} className={(touched.coauthors && touched.coauthors[i]?.created_at && errors.coauthors && errors.coauthors[i]?.created_at ? "form-control required" : "form-control")}
                                                                                />
                                                                            </div>
                                                                            {i == 0 ? <>
                                                                                <a className="add-box" role="button" onClick={() => {
                                                                                    arrayHelpers.push({
                                                                                        user_id: "",
                                                                                        rate: "0",
                                                                                        created_at: "2019-01-01"
                                                                                    });
                                                                                }}>
                                                                                    <img src="img/Icon material-add-box.png" alt="" />
                                                                                </a>
                                                                                <a className="add-box" role="button" onClick={() => {
                                                                                    arrayHelpers.replace(i, {
                                                                                        user_id: "",
                                                                                        rate: "0",
                                                                                        created_at: "2019-01-01"
                                                                                    })
                                                                                }}>
                                                                                    <img src="img/Icon ionic-md-add.png" alt="" />
                                                                                </a>
                                                                            </>
                                                                                : <a className="add-box" role="button" onClick={() => {
                                                                                    arrayHelpers.remove(i);
                                                                                }}>
                                                                                    <img src="img/Icon ionic-md-add.png" alt="" />
                                                                                </a>}
                                                                        </div>
                                                                    </main>
                                                                );
                                                            })
                                                        }} />

                                                    </div>
                                                </div>
                                                <div className="form-log">
                                                    <button type="submit" className="ml-auto">
                                                        {this.state.isLoading ? (
                                                            <i className="fa fa-spinner fa-2x rotating "></i>
                                                        ) : (!this.props.match.params.id ? "Добавить" : "Изменить")}
                                                    </button>
                                                </div>

                                            </form>
                                        );
                                    }}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(function (state: any) {
    return {
        auth: state.auth
    };
})(withTranslation()(SingleObject));
